var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LoggedIn',{attrs:{"top":true}},[_c('div',{staticClass:"mx-auto",attrs:{"data-cy":"settings-page"}},[_c('code-settings'),_c('team')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }